import ReactECharts, { EChartsReactProps } from 'echarts-for-react';

export default function Chart({
	option,
	opts = { renderer: 'canvas', width: 'auto', height: 'auto' },
	...props
}: EChartsReactProps) {
	return <ReactECharts option={option} opts={opts} {...props} />;
}
